'use strict';

(function () {
  'use strict';

  angular.module('actionHistorys', ['ui.router', 'common']);
})();